import { render, staticRenderFns } from "./VistaVisualizacionComisiones.vue?vue&type=template&id=2060f819"
import script from "./VistaVisualizacionComisiones.vue?vue&type=script&lang=js"
export * from "./VistaVisualizacionComisiones.vue?vue&type=script&lang=js"
import style0 from "./VistaVisualizacionComisiones.vue?vue&type=style&index=0&id=2060f819&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports